import React, {Component} from 'react';
import ZapierKey from './zapier-key';
import ZapierSample from './zapier-sample';
import Section from '../../../libs/react-components-admin/section/section';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';
import IntegrationOnlyForStandalone from '../common/integration-only-for-standalone';

export default class Zapier extends Component {

  render() {
    return <Section title="Integration - Zapier">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10">
          <IntegrationOnlyForStandalone/>
          <ol>
            <li>
              <OpenInNewLink href="https://zapier.com/developer/public-invite/95359/2cbb2be62f4f4d51da06dfba69c8773b/">
                Connect with Acerill Custom Forms on Zapier
              </OpenInNewLink>
            </li>
            <li>Click on &apos;Make a new Zap&apos;</li>
            <li>Under &apos;App event&apos;, search for &apos;Acerill Custom Forms&apos;</li>
            <li>Under &apos;Trigger event&apos;, choose &apos;Form Submitted&apos;</li>
            <li>To connect with your Acerill Custom Forms account, use the following details:
              <ZapierKey />
            </li>
            <li>
              Test trigger:
              <ul>
                <li>Submit one of your forms below.</li>
                <li>Click on &apos;Test trigger&apos; in Zapier.</li>
              </ul>
              If Zapier displays &quot;A Form Submitted could not be found&quot;, please try again.
              <ZapierSample />
            </li>
          </ol>
        </div>
      </div>
    </Section>
  }

}
